import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { SidePanelBase } from "../../../../common/components/side-panel-base.class";
import { LandownerPassthroughProgramHistory } from "../../../../common/models/permit.model";
import { SidePanelService } from '../../../../common/services/side-panel.service';


@Component({
    selector: 'app-program-timeline',
    templateUrl: './program-timeline.component.html',
    styleUrls: ['./program-timeline.component.scss'],
    standalone: false
})
export class ProgramTimelineComponent extends SidePanelBase implements OnInit {
    static componentName = "ProgramTimelineComponent";

    editorOpen: boolean = false;


    history: LandownerPassthroughProgramHistory[];

    subscription: Subscription = new Subscription();


    constructor(private service: SidePanelService) {
        super();
    }

    ngOnInit() {
        const data$ = this.service.update().pipe(
            map((data: any) => {
                if (data != null && data.data != null) {
                    const sections = data.data.sections;
                    if (sections != null && sections.length > 0) {
                        this.history = sections[0].componentData as LandownerPassthroughProgramHistory[];
                    }
                }
                return this.history
            })
        ).subscribe(
            (history: LandownerPassthroughProgramHistory[]) => {
                this.history = history.sort((a, b) => {
                    if (a.recordedDate < b.recordedDate) return -1;
                    if (a.recordedDate > b.recordedDate) return 1;
                    return 0;
                });
            },
            (error) => { console.error(error); }
        );
        this.subscription.add(data$);
        this.history = this.componentData as LandownerPassthroughProgramHistory[];
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

}
